import { put, select, takeEvery, takeLatest, call } from 'redux-saga/effects';
import NotificationHandler from 'utils/notification';
import { actions } from '../slices/ShippingOrderSlice';
import { actions as transportElecActions } from '../slices/TransportOrderElecSlice';
import { actions as reportTransportElecActions } from '../slices/ReportTransportOrderElecSlice';
import { transportOrdersApi } from '../../../api';
import ModalHandler from 'utils/modal';
import { roles } from '../const';
// Lệnh vận chuyển
const getSearchCriteria = (state) => state.shippingOrder.searchCriteria;
const getSearchCriteriaBelow = (state) => state.shippingOrder.searchCriteriaBelow;
const getType = (state) => state.shippingOrder.typeActive;
const getSearchCriteriaFile = (state) => state.shippingOrder.searchCriteriaFile;
const getSearchCriteriaTransportElec = (state) => state.transportOrderElec.searchCriteria;
const getSearchCriteriaTransportElecDetails = (state) => state.transportOrderElec.searchCriteriaDetails;

// Lấy danh sách chưa có id
function* getTransportOrdersSaga({ payload }) {
    try {
        const { getTransportOrders } = transportOrdersApi;
        const { routeName, ...rest } = payload || {};
        const response = yield getTransportOrders(rest);

        const transportCodeListWithIndex = response?.data?.transportCodeList.map((item, index) => ({
            ...item,
            index,
        }));
        yield put({ type: actions.get_list_succeed.type, payload: transportCodeListWithIndex });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.get_list_failed.type, payload: error });
    }
}

// Xác nhận lệnh vận chuyển
function* createTransportOrderSaga({ payload }) {
    try {
        const { createTransportOrders } = transportOrdersApi;
        yield createTransportOrders(payload);
        yield put({ type: actions.create_transport_order_succeed.type });
        NotificationHandler.notifySuccess('Lưu thành công');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: actions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.create_transport_order_succeed.type, payload: error });
    }
}
// Lấy danh sách đã có xác nhận

function* getFindTransportOrdersSaga({ payload }) {
    try {
        const { type, body } = payload || {};
        const { getFindTransportOrders } = transportOrdersApi;
        const { routeName, ...rest } = body || {};
        const response = yield getFindTransportOrders(type, rest);
        const transportCodeListWithIndex = response?.data?.items?.map((item, index) => ({
            ...item,
            index,
        }));

        yield put({ type: actions.get_list_find_transport_orders_succeed.type, payload: { data: transportCodeListWithIndex, total: response?.data?.total } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.get_list_find_transport_orders_failed.type, payload: error });
    }
}

// Lấy danh sách đã xác nhận form 2
function* getFindTransportOrdersBelowSaga({ payload }) {
    try {
        const { type, body } = payload || {};
        const { getFindTransportOrders } = transportOrdersApi;
        const { routeName, ...rest } = body || {};
        const response = yield getFindTransportOrders(type, rest);
        const transportCodeListWithIndex = response?.data?.items?.map((item, index) => ({
            ...item,
            index,
        }));
        // const typeIndex = roles.findIndex((item) => item.key == type);
        yield put({ type: actions.get_list_find_transport_orders_below_succeed.type, payload: { data: transportCodeListWithIndex, total: response?.data?.total } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.get_list_find_transport_orders_failed.type, payload: error });
    }
}

function* updateTransportOrdersSaga({ payload }) {
    try {
        const { body, isTop } = payload || {};
        const { updateTransportOrders } = transportOrdersApi;
        yield updateTransportOrders(body);
        yield put({ type: actions.update_transport_order_succeed.type });
        NotificationHandler.notifySuccess('Lưu thành công');

        const type = yield select(getType);

        if (isTop) {
            const searchCriteria = yield select(getSearchCriteria);
            yield put({ type: actions.get_list_find_transport_orders.type, payload: { body: searchCriteria, type: roles[type - 1].key } });
        } else {
            const searchCriteria = yield select(getSearchCriteriaBelow);
            yield put({ type: actions.get_list_find_transport_orders_below.type, payload: { body: searchCriteria, type: roles[type].key } });
        }
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.update_transport_order_succeed.type, payload: error });
    }
}

function* getHistorySaga({ payload }) {
    try {
        const { historyTransportOrders } = transportOrdersApi;
        const response = yield historyTransportOrders(payload);
        yield put({ type: actions.save_history.type, payload: response.data });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
    }
}
// Xác nhận từ thu ngân hoặc tổ nghiệm thu
function* confirmTransportOrdersSaga({ payload }) {
    try {
        const { confirmTransportOrders } = transportOrdersApi;
        const { type, body } = payload || {};
        yield confirmTransportOrders(type, body);
        yield put({ type: actions.confirm_transport_order_succeed.type });
        const searchCriteria = yield select(getSearchCriteria);
        const typeIndex = roles.findIndex((item) => item.key == type);

        yield put({ type: actions.get_list_find_transport_orders.type, payload: { body: searchCriteria, type: roles[typeIndex - 1].key } });

        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.confirm_transport_order_succeed.type });
    }
}

// get list file
function* getFileTransportOrdersSaga({ payload }) {
    try {
        const { getFileTransportOrders } = transportOrdersApi;
        const response = yield getFileTransportOrders(payload);
        yield put({ type: actions.get_file_transport_order_succeed.type, payload: response?.data });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.get_file_transport_order_succeed.type });
    }
}
function* deleteFileTransportOrdersSaga({ payload }) {
    try {
        const { id } = payload || {};
        const { deleteFileTransportOrders } = transportOrdersApi;
        yield deleteFileTransportOrders(id);
        NotificationHandler.notifySuccess('Xóa thành công');
        const searchCriteria = yield select(getSearchCriteriaFile);
        yield put({ type: actions.get_file_transport_order.type, payload: searchCriteria });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.delete_file_transport_order_succeed.type });
    }
}

function* getTransportOrdersPrintSaga({ payload }) {
    try {
        const { type, body } = payload || {};
        const { getFindTransportOrders } = transportOrdersApi;
        const { routeName, code, ...rest } = body || {};
        const response = yield getFindTransportOrders(type, rest);
        yield put({ type: actions.get_transport_orders_print_succeed.type, payload: response?.data?.items });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.get_list_find_transport_orders_failed.type, payload: error });
    }
}

function* uploadFileTransportOrdersSaga({ payload }) {
    try {
        const { body } = payload || {};
        const { uploadFileTransportOrders } = transportOrdersApi;
        yield uploadFileTransportOrders(body);
        NotificationHandler.notifySuccess('Upload thành công');
        const searchCriteria = yield select(getSearchCriteriaFile);
        yield put({ type: actions.get_file_transport_order.type, payload: searchCriteria });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.upload_file_transport_orders_succeed.type });
    }
}

// Lệnh vận chuyển điện tử
function* getFindTransportOrdersElecSaga({ payload }) {
    try {
        const { getTransportOrdersElec } = transportOrdersApi;
        const { callback, ...rest } = payload || {};
        const response = yield getTransportOrdersElec({ ...rest });
        if (payload?.export) {
            NotificationHandler.notifyDownloadBox(response.data);
            yield put({ type: transportElecActions.request_export_success.type });
        } else {
            yield put({ type: transportElecActions.get_list_succeed.type, payload: { data: response?.data?.items, total: response?.data?.total, extra: response?.data?.extra } });
            if (callback) {
                yield call(callback, response?.data?.items || [], response?.data);
            }
        }
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: transportElecActions.get_list_failed.type, payload: error });
    }
}
function* summaryConfirm({ payload }) {
    try {
        const { summaryConfirmEnd } = transportOrdersApi;
        yield summaryConfirmEnd(payload);
        yield put({ type: transportElecActions.summary_confirm_success.type });
        NotificationHandler.notifySuccess('Xác nhận thành công');
        const searchCriteria = yield select(getSearchCriteriaTransportElec);
        yield put({ type: transportElecActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: transportElecActions.summary_confirm_false.type });
    }
}
function* summaryResign({ payload }) {
    try {
        const { summaryResign } = transportOrdersApi;
        yield summaryResign(payload);
        yield put({ type: transportElecActions.summary_confirm_success.type });
        NotificationHandler.notifySuccess('Ký lại thành công');
        const searchCriteria = yield select(getSearchCriteriaTransportElec);
        yield put({ type: transportElecActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: transportElecActions.summary_confirm_false.type });
    }
}
function* summaryResend({ payload }) {
    try {
        const { summaryResend } = transportOrdersApi;
        yield summaryResend(payload);
        yield put({ type: transportElecActions.summary_confirm_success.type });
        NotificationHandler.notifySuccess('Gửi lại thành công');
        const searchCriteria = yield select(getSearchCriteriaTransportElec);
        yield put({ type: transportElecActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: transportElecActions.summary_confirm_false.type });
    }
}

function* detailResign({ payload }) {
    try {
        const { detailsResign } = transportOrdersApi;
        yield detailsResign(payload);
        yield put({ type: transportElecActions.summary_confirm_success.type });
        NotificationHandler.notifySuccess('Ký lại thành công');
        const searchCriteria = yield select(getSearchCriteriaTransportElec);
        yield put({ type: transportElecActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: transportElecActions.summary_confirm_false.type });
    }
}
function* detailResend({ payload }) {
    try {
        const { detailsResend } = transportOrdersApi;
        yield detailsResend(payload);
        yield put({ type: transportElecActions.summary_confirm_success.type });
        NotificationHandler.notifySuccess('Gửi lại thành công');
        const searchCriteria = yield select(getSearchCriteriaTransportElec);
        yield put({ type: transportElecActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: transportElecActions.summary_confirm_false.type });
    }
}

function* detailsSave({ payload }) {
    const searchCriteriaDetails = yield select(getSearchCriteriaTransportElecDetails);
    try {
        const { detailsSave } = transportOrdersApi;
        yield detailsSave(payload);
        yield put({ type: transportElecActions.summary_confirm_success.type });
        const searchCriteria = yield select(getSearchCriteriaTransportElec);
        yield put({ type: transportElecActions.get_list.type, payload: { ...searchCriteria } });
        NotificationHandler.notifySuccess('Lưu thành công');

        yield getdDetailsTransportOrdersElecSaga({ payload: searchCriteriaDetails });
        if (payload?.callback) {
            try {
                yield call(payload.callback);
            } catch (e) {
                // ignore callback errors
            }
        }
    } catch (error) {
        yield getdDetailsTransportOrdersElecSaga({ payload: searchCriteriaDetails });
        NotificationHandler.notifyError(error.message);
        yield put({ type: transportElecActions.summary_confirm_false.type });
    }
}

function* getdDetailsTransportOrdersElecSaga({ payload }) {
    try {
        const { details } = transportOrdersApi;
        const response = yield details({ ...payload });
        if (payload?.export) {
            NotificationHandler.notifyDownloadBox(response.data);
            yield put({ type: transportElecActions.request_export_details_success.type });
        } else {
            yield put({ type: transportElecActions.get_details_list_succeed.type, payload: { data: response?.data?.items, total: response?.data?.total } });
        }
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: transportElecActions.get_details_list_failed.type, payload: error });
    }
}

function* getReportTransportOrdersElecSaga({ payload }) {
    try {
        const { getReport } = transportOrdersApi;
        const response = yield getReport({ ...payload });

        yield put({ type: transportElecActions.get_list_report_succeed.type, payload: { data: response?.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: transportElecActions.get_list_report_failed.type, payload: error });
    }
}

//report transport order elec
function* getDetailReportTransportOrdersElecSaga({ payload }) {
    try {
        const { getReportTransportOrderElect } = transportOrdersApi;
        const response = yield getReportTransportOrderElect({ ...payload });
        if (payload?.export) {
            NotificationHandler.notifyDownloadBox(response.data);
            yield put({ type: reportTransportElecActions.request_export_success.type });
        } else {
            yield put({ type: reportTransportElecActions.get_list_succeed.type, payload: { data: response?.data?.items, total: response?.data?.total } });
        }
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: reportTransportElecActions.get_list_failed.type, payload: error });
    }
}

function* operatorConfirm({ payload }) {
    try {
        const { operatorConfirm } = transportOrdersApi;
        yield operatorConfirm(payload);
        yield put({ type: transportElecActions.operator_confirm_success.type });
        NotificationHandler.notifySuccess('Xác nhận thành công');
        const searchCriteria = yield select(getSearchCriteriaTransportElec);
        yield put({ type: transportElecActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: transportElecActions.operator_confirm_false.type });
    }
}

function* confirmAccepted({ payload }) {
    try {
        const { confirmAccepted } = transportOrdersApi;
        yield confirmAccepted(payload);
        yield put({ type: transportElecActions.confirm_not_accepted_success.type });
        NotificationHandler.notifySuccess(`Xác nhận ${payload.accepted ? '' : 'không'} nghiệm thu thành công`);

        // Refresh danh sách dựa vào shippingType
        if (payload.shippingType === 'SHIPPING_ORDER_DETAIL') {
            const searchCriteriaDetails = yield select(getSearchCriteriaTransportElecDetails);
            yield put({ type: transportElecActions.get_details_list.type, payload: { ...searchCriteriaDetails } });
            // Reload thêm list parent
            const searchCriteria = yield select(getSearchCriteriaTransportElec);
            yield put({ type: transportElecActions.get_list.type, payload: { ...searchCriteria } });
        } else {
            const searchCriteria = yield select(getSearchCriteriaTransportElec);
            yield put({ type: transportElecActions.get_list.type, payload: { ...searchCriteria } });
        }
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: transportElecActions.confirm_not_accepted_failed.type });
    }
}

// Saga đồng bộ sản lượng vé
function* syncTicketQuantitySaga({ payload }) {
    const searchCriteriaDetails = yield select(getSearchCriteriaTransportElecDetails);
    try {
        const { syncTicketQuantity } = transportOrdersApi;
        yield call(syncTicketQuantity, payload);
        yield put(transportElecActions.sync_ticket_quantity_success());
        const searchCriteria = yield select(getSearchCriteriaTransportElec);
        yield put({ type: transportElecActions.get_list.type, payload: { ...searchCriteria } });
        NotificationHandler.notifySuccess('Đã đồng bộ sản lượng vé.');
        yield getdDetailsTransportOrdersElecSaga({ payload: searchCriteriaDetails });
        if (payload?.callback) {
            try {
                yield call(payload.callback);
            } catch (e) {
                // ignore callback errors
            }
        }
    } catch (error) {
        yield put(transportElecActions.sync_ticket_quantity_failed({ error: error?.message || 'Đã xảy ra lỗi khi đồng bộ sản lượng vé.' }));
        NotificationHandler.notifyError(error?.message || 'Đã xảy ra lỗi khi đồng bộ sản lượng vé.');
    }
}
function* watchRequestDetail() {
    yield takeLatest(actions.get_list, getTransportOrdersSaga);
    yield takeLatest(actions.create_transport_order, createTransportOrderSaga);
    yield takeEvery(actions.get_list_find_transport_orders, getFindTransportOrdersSaga);
    yield takeEvery(actions.update_transport_order, updateTransportOrdersSaga);
    yield takeLatest(actions.get_history, getHistorySaga);
    yield takeEvery(actions.confirm_transport_order, confirmTransportOrdersSaga);
    yield takeEvery(actions.get_list_find_transport_orders_below, getFindTransportOrdersBelowSaga);
    yield takeEvery(actions.get_file_transport_order, getFileTransportOrdersSaga);
    yield takeEvery(actions.delete_file_transport_order, deleteFileTransportOrdersSaga);
    yield takeEvery(actions.get_transport_orders_print, getTransportOrdersPrintSaga);
    yield takeEvery(actions.upload_file_transport_orders, uploadFileTransportOrdersSaga);
    // Lệnh vận chuyển điện tử
    yield takeLatest(transportElecActions.get_list, getFindTransportOrdersElecSaga);
    yield takeLatest(transportElecActions.summary_confirm, summaryConfirm);
    yield takeLatest(transportElecActions.summary_resign, summaryResign);
    yield takeLatest(transportElecActions.summary_resend, summaryResend);
    yield takeLatest(transportElecActions.detail_resign, detailResign);
    yield takeLatest(transportElecActions.detail_resend, detailResend);
    yield takeLatest(transportElecActions.details_save, detailsSave);
    yield takeLatest(transportElecActions.get_details_list, getdDetailsTransportOrdersElecSaga);
    yield takeLatest(transportElecActions.get_list_report, getReportTransportOrdersElecSaga);
    yield takeLatest(transportElecActions.operator_confirm, operatorConfirm);
    yield takeLatest(transportElecActions.confirm_not_accepted, confirmAccepted);

    // Kiểm tra sản lượng vé
    yield takeLatest(transportElecActions.sync_ticket_quantity, syncTicketQuantitySaga);

    // report transport order elec
    yield takeLatest(reportTransportElecActions.get_list, getDetailReportTransportOrdersElecSaga);
}

export default watchRequestDetail;
